import BaseModelAPI from '../BaseModelAPI';

export default class PicType extends BaseModelAPI {
	static entity = 'pictype';
	static entityName = 'pictype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}